<template>
  <!-- content - start -->
  <div class="recruit content">

    <div class="banner-sub">
      <img :src="productInfo.banner" alt="">
    </div>
    <div class="wrap">
      <div class="top-box">
        <h2>{{productInfo.title}}</h2>
        <span v-html="productInfo.introduction"></span>
        <div class="top-image">
          <img :src="productInfo.detailImgList[0]" alt="">
        </div>
      </div>
      <div class="product-flex-box">
        <div class="flex-left-box">
          <!-- 方案介绍 start -->
          <div class="join-part1 mt30">
            <div class="zhaop">
              <div class="join-text" v-html="productInfo.detail"></div>
            </div>
          </div>
          <!-- 方案介绍 end -->

          <!-- 产品特点 start -->
          <div class="join-part1 product-content" v-if="productInfo.traitList && productInfo.traitList.length > 0">
            <div class="zhaop">
              <h2>产品特点</h2>
              <div class="product-text">
                <div class="pro-txt-item" v-for="(trait,index) in productInfo.traitList" :key="index">
                  <span class="product-item-number">{{ index + 1}}</span>
                  <div class="product-item-detail">
                    <p v-text="trait.value"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 产品特点 end -->

          <!-- 产品参数 start -->
          <div class="join-part1 product-content" v-if="productInfo.paramsList && productInfo.paramsList.length > 0">
            <div class="zhaop">
              <h2>产品参数</h2>
              <div class="join-table">
                <table cellpadding="0" cellspacing="0">
                  <thead>
                    <tr>
                      <th><span>参数名称</span></th>
                      <th><span>参数值</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(param,index) in productInfo.paramsList">
                      <tr :key="index" v-if="productInfo.paramsList && productInfo.paramsList.length > 0">
                        <td><span>{{ param.name }}</span></td>
                        <td><span>{{param.value}}</span></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- 产品参数 end -->

          <!-- 成功案例 start -->
          <div class="join-part1 product-demo" v-if="productInfo.projectList && productInfo.projectList.length > 0">
            <div class="zhaop">
              <h2>成功案例</h2>
              <div class="demo-list">
                <div class="item" @click="successProjectHandler(project.id)" v-for="project in productInfo.projectList"
                  :key="project.id">
                  <img :src="project.img" class="item-img" alt="">
                  <div class="item-p-box">
                    <p class="item-p" v-text="project.title"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-right-box">
          <h2 class="new-product">最新推荐</h2>
          <template v-for="(item, idx) in productAllList">
            <div class="item" :key="idx" v-if="idx < 10" @click="productHandler(item.id)">
              <p>{{item.title}}</p>
              <img v-if="idx === 0" :src="item.imgUrl" alt="">
            </div>
          </template>
        </div>
      </div>

      <!-- 成功案例 end -->
      <div style="height: 72px; width: 100%;clear: both;"></div>
    </div>
  </div>
  <!-- content - end -->
</template>

<script>
import { ApiWebIndexProductInfo, ApiWebProductList } from '../api/product'
export default {
  name: 'product',
  data() {
    return {
      // 所有产品list
      productAllList: [],
      // 产品子导航的展示隐藏
      subNavFlag: false,
      // 需要查看的产品详情的id
      productId: null,
      // 产品详情
      productInfo: {
        title: '', // 产品标题
        detail: '', // 产品详情
        banner: '', // 产品详情banner图片
        detailImg: '', // 产品详情介绍图(以逗号分割字符串)
        introduction: '', // 产品介绍
        traitList: [], // 产品特点
        paramsList: [], // 参数数组
        projectList: [] // 成功案例（查询推荐的成功方案）
      }
    }
  },
  mounted() {
    // 接收由其它页面传过来的产品id
    this.productId = this.$route.params.productId || this.$store.getters['product/getProductId']
    // 获取产品详情
    this.getProductInfo(this.productId)
    this.getProductListAll()
    var swiper = new Swiper('.swiper-container', { // eslint-disable-line no-unused-vars
      // pagination: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 4,
      centeredSlides: true,
      paginationClickable: true,
      spaceBetween: 30,
      loop: true
    })
  },
  methods: {
    /**
     * 产品点击操作
     * @param {c} id 
     */
    productHandler (id) {
      this.$store.commit('product/setProductId', id)
      this.getProductInfo(id)
    },
    /**
     * 获取所有产品list
     */
    getProductListAll() {
      ApiWebProductList().then(({ data }) => {
        if (data && data.status === 0) {
          this.productAllList = data.data.list
        }
      })
    },
    /**
     * 获取产品详情
     * id => 产品详情id
     */
    getProductInfo(id) {
      ApiWebIndexProductInfo(id).then(({ data }) => {
        if (data && data.status === 0) {
          this.$set(this.productInfo, 'title', data.data.title)
          this.$set(this.productInfo, 'banner', data.data.banner)
          this.$set(this.productInfo, 'introduction', data.data.introduction)
          this.$set(this.productInfo, 'detail', data.data.detail)
          this.$set(this.productInfo, 'traitList', data.data.traits)
          this.$set(this.productInfo, 'paramsList', data.data.params)
          this.$set(this.productInfo, 'projectList', data.data.projects)
          this.$set(this.productInfo, 'detailImgList', data.data.detailImgs)
        }
      })
    },
    /**
     * 查看成功方案详情
     * @param id 方案id
     */
    successProjectHandler(id) {
      this.$store.commit('product/setProjectId', id)
      this.$router.push({ name: 'productDemo', params: { projectId: id } })
    },
    /**
     * 打开/关闭  产品推荐导航 操作
     */
    showSubHandler() {
      this.subNavFlag = !this.subNavFlag
    }
  }
}
</script>

<style scoped lang="less">
@import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/product-detail.vue